import React from 'react';
import SideNav from '../SideNav/SideNav';

const VoteSummary = () => {
  return (
    <div className="min-h-screen bg-[#020817] text-white">
      <SideNav />
      
      <div className="ml-[var(--sidenav-width)] transition-[margin-left] duration-200 ease-out pt-6">
        <div className="p-8">
          <h1 className="text-4xl font-bold text-green-400 mb-6">Vote Summary</h1>
          <p className="text-gray-300 mb-8">
            Comprehensive analysis of Brownlow Medal voting patterns and historical data.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-gray-900 rounded-xl p-6 border border-gray-700">
              <h3 className="text-green-400 text-sm font-semibold mb-2">TOTAL VOTES</h3>
              <p className="text-3xl font-bold text-white">1,247</p>
              <p className="text-gray-400 text-sm mt-1">Across all rounds</p>
            </div>
            
            <div className="bg-gray-900 rounded-xl p-6 border border-gray-700">
              <h3 className="text-green-400 text-sm font-semibold mb-2">AVERAGE PER GAME</h3>
              <p className="text-3xl font-bold text-white">2.8</p>
              <p className="text-gray-400 text-sm mt-1">Votes per match</p>
            </div>
            
            <div className="bg-gray-900 rounded-xl p-6 border border-gray-700">
              <h3 className="text-green-400 text-sm font-semibold mb-2">TOP VOTE GETTER</h3>
              <p className="text-3xl font-bold text-white">P. Cripps</p>
              <p className="text-gray-400 text-sm mt-1">Carlton midfielder</p>
            </div>
          </div>
          
          <div className="mt-8 bg-gray-900 rounded-xl p-6 border border-gray-700">
            <h3 className="text-xl font-bold text-white mb-4">Recent Vote Activity</h3>
            <div className="space-y-3">
              <div className="flex justify-between items-center py-2 border-b border-gray-800">
                <span className="text-white">Round 23 - Carlton vs Richmond</span>
                <span className="text-green-400">3 votes - P. Cripps</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-800">
                <span className="text-white">Round 23 - Collingwood vs Brisbane</span>
                <span className="text-green-400">3 votes - N. Daicos</span>
              </div>
              <div className="flex justify-between items-center py-2">
                <span className="text-white">Round 22 - Melbourne vs Sydney</span>
                <span className="text-green-400">3 votes - C. Petracca</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoteSummary;